import { FormFieldBlueprint } from '@backstage/plugin-scaffolder-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';

export const userEmailFormFieldExtension: ExtensionDefinition =
  FormFieldBlueprint.make({
    name: 'user-email-form-field-extension',
    params: {
      field: () => import('./user-email-input').then(m => m.UserEmailFormField),
    },
  });
